<template>
  <DiscordTechDesign variant="classic" />
</template>

<script>
import DiscordTechDesign from './DiscordTechDesign.vue';

export default {
  name: 'DiscordTech2',
  components: { DiscordTechDesign },
};
</script>
